import React from "react";
import { certifications } from "../../data/process";
export function CertificationStrip() {
  return <section aria-label="Certifications et conformité" className="border-b border-line bg-cream" data-id="element-77" data-mp="1nmq5rxdy6yea">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-5 px-5 py-8 md:px-10 lg:flex-row lg:items-center lg:gap-12" data-id="element-78" data-mp="1ivhtmtl8gyxf">
        <p className="shrink-0 text-sm text-stone" data-id="element-79" data-mp="1dwneq2qdzuil">Certifié et conforme</p>
        <ul className="flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-80" data-mp="19vv2d0m7x9i3">
          {certifications.map(c => <li key={c} className="whitespace-nowrap font-display text-xl text-olive" data-id="element-81" data-mp="14vgxtsjtshot">
              {c}
            </li>)}
        </ul>
      </div>
    </section>;
}